import * as React from 'react';
import { observer } from 'mobx-react';
import { translation, currencyFormatter, translate, pointsFormatter } from 'easit--localization';
import { SubmitMessage } from 'common--design-library';
import * as classNames from 'classnames';

export interface ITicketAndCouponProps {
    onAcceptOrReject: (hintAccepted: boolean) => void;
    hint: number;
    currencyIsMoney: boolean;
    isAcceptingHintInProgress: boolean;
    className?: string;
    removeMargins?: boolean;
    canSwapPrimarySecondaryForButtons: boolean;
}

export const TicketAndCouponHint: React.FC<ITicketAndCouponProps> = observer((props: ITicketAndCouponProps) => { //TODO do we need observer here?
    return (
        <div className={classNames("rejected-hint", props.className)}>
            <SubmitMessage className={classNames("no-bg", props.removeMargins && "m-0")}>
                {translate("coupon_liveHint_Question", { value: props.currencyIsMoney ? currencyFormatter.format(props.hint) : pointsFormatter.format(props.hint) }).coupon_liveHint_Question}
            </SubmitMessage>

            <div className="pay-buttons d-flex">
                <button className={`btn ${__IsMTSTipos__ || props.canSwapPrimarySecondaryForButtons ? "btn-primary" : "btn-secondary"} ${props.isAcceptingHintInProgress ? "disabled" : ""} flex-grow-1`} onClick={() => !props.isAcceptingHintInProgress && props.onAcceptOrReject(false)}>{translation().coupon_liveHint_No}</button>
                <button className={`btn ${__IsMTSTipos__ ? "btn-success" : (props.canSwapPrimarySecondaryForButtons ? "btn-secondary" : "btn-primary")} ${props.isAcceptingHintInProgress ? "disabled" : ""} flex-grow-1`} onClick={() => !props.isAcceptingHintInProgress && props.onAcceptOrReject(true)}>{translation().coupon_liveHint_Yes} {props.isAcceptingHintInProgress && <span className="fas fa-spinner fa-spin"></span>}</button>
            </div>
        </div>
    )
});